/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-production': {
    width: 14,
    height: 12,
    viewBox: '0 0 14 12',
    data: '<g _fill="#595959" fill-rule="nonzero"><path pid="0" d="M7.098 5.172a.125.125 0 00-.196 0l-1.75 2.214a.125.125 0 00.098.202h1.155v3.787c0 .069.056.125.125.125h.937a.125.125 0 00.125-.125V7.589H8.75c.105 0 .162-.12.098-.202l-1.75-2.215z"/><path pid="1" d="M11.678 3.73A5.002 5.002 0 007.003.5a5 5 0 00-4.675 3.228 3.126 3.126 0 00.795 6.147h.627a.125.125 0 00.125-.125v-.938a.125.125 0 00-.125-.124h-.627a1.937 1.937 0 01-1.527-3.131c.262-.334.627-.576 1.034-.684l.592-.154.217-.572a3.838 3.838 0 011.377-1.77 3.783 3.783 0 012.187-.691c.79 0 1.545.239 2.188.69a3.84 3.84 0 011.376 1.77l.216.571.59.156c.847.229 1.44.999 1.44 1.877 0 .517-.202 1.005-.568 1.37a1.923 1.923 0 01-1.368.568h-.627a.125.125 0 00-.125.124v.938c0 .069.056.125.125.125h.627a3.124 3.124 0 00.801-6.145z"/></g>'
  }
})
